/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ScreenerLeadPointClickCareStatus = {
    NoStatus: 'No Status',
    PushedToPointClickCare: 'Pushed to PointClickCare'
} as const;
export type ScreenerLeadPointClickCareStatus = typeof ScreenerLeadPointClickCareStatus[keyof typeof ScreenerLeadPointClickCareStatus];


export function ScreenerLeadPointClickCareStatusFromJSON(json: any): ScreenerLeadPointClickCareStatus {
    return ScreenerLeadPointClickCareStatusFromJSONTyped(json, false);
}

export function ScreenerLeadPointClickCareStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScreenerLeadPointClickCareStatus {
    return json as ScreenerLeadPointClickCareStatus;
}

export function ScreenerLeadPointClickCareStatusToJSON(value?: ScreenerLeadPointClickCareStatus | null): any {
    return value as any;
}

